<template>
  <div>
    <!-- TODO consider only showing undo when undo is feasibe and allowing disabling of delete, likely requires use of the slots -->
    <!-- Note use of binding to value without v-model -->
    <div v-if="isString">
      <v-text-field
        v-if="edit"
        :ref="refKey"
        solo
        dense
        clearable
        append-outer-icon="mdi-delete-outline"
        v-model="literalValue"
        @click:append-outer="onDelete"
        @input="onInput"
        :rules="[rules.notEmpty]"
      >
        <!-- Append Undo Button with Tooltip -->
        <template v-slot:append>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="onUndo">
                mdi-undo
              </v-icon>
            </template>
            <span>{{ undoLiteral.value || 'blank' }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
      <span v-else class="d-inline-flex align-center">
        <highlighted-text :value="literal.value" :highlights="highlights" />
        <copy-icon :value="literal.value" />
      </span>
    </div>

    <!-- TODO extract into string-map component BUT how will it know its a map of string -> string -->
    <div v-if="isJson">
      <div v-for="(pair, index) of pairs" :key="pair[0]" class="border-left">
        <!-- display: block -->
        <span class="d-inline-flex align-center">
          <v-icon small left color="secondary">{{
            index ? 'mdi-circle-small' : 'mdi-code-json'
          }}</v-icon>
          {{ pair[0] + ' → ' + pair[1] }}
          <copy-icon :value="String(pair[1])" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import HighlightedText from './HighlightedText.vue'
import CopyIcon from './CopyIcon.vue'

import { Iris, Literal } from '@/rec-cache/rec-cache-types'

export default {
  components: { HighlightedText, CopyIcon },
  props: {
    literal: {
      type: Object,
      default: () => {
        return new Literal()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    literalValue: '',
    undoLiteral: new Literal(),
    deleteProperty: false,
    // TODO allow parent to set not empty rule error message in props...
    rules: {
      notEmpty: (value) => !!value || 'Value must be defined!',
    },
    refKey: '',
  }),
  watch: {
    literal: function (newValue) {
      this.literalValue = newValue.value
    },
    edit: function (newValue) {
      // The undo literal is sampled whenever edit is turned on.
      if (newValue) {
        this.undoLiteral = this.literal.clone()
        this.autoFocus()
      }
    },
  },
  computed: {
    isJson: function () {
      return this.literal.datatype == Iris.rdfJSON
    },
    isString: function () {
      return this.literal.datatype == Iris.xsdString
    },
    pairs: function () {
      return this.isJson ? Object.entries(this.literalValue) : []
    },
  },
  created: function () {
    this.literalValue = this.literal.value
    this.refKey = Math.random().toString(36).slice(2, 8)
    // console.log('LITERAL.CREATED', this.value, this.literal)
  },
  mounted() {
    // console.log('components.literal-value.mounted', this.literal)
    this.autoFocus()
  },
  methods: {
    // Focuses the input text field if empty, ie it just created.
    autoFocus() {
      this.$nextTick(() => {
        if (this.literalValue === '' && this.$refs[this.refKey]) {
          this.$refs[this.refKey].focus()
        }
      })
    },

    onInput: function (value) {
      // The Vuetify input event specifically returns the bound value, not an event object.
      this.$emit('input', new Literal(value))
    },
    onUndo: function () {
      this.$emit('input', this.undoLiteral)
    },
    onDelete: function () {
      // The delete event emits the current value of the literal to allow parent to identify which property/triple to delete.
      this.$emit('delete', this.literal)
    },
  },
}
</script>
